import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BODY_BG_URL = `${process.env.PUBLIC_URL ?? ""}/assets/bg-pc.png`;

function applyGameBodyBg() {
  document.body.style.backgroundColor = "#0a0000";
  document.body.style.backgroundImage = `url("${BODY_BG_URL}")`;
  document.body.style.backgroundSize = "cover";
  document.body.style.backgroundPosition = "center";
  document.body.style.backgroundRepeat = "no-repeat";
  document.body.style.backgroundAttachment = window.matchMedia(
    "(max-width: 768px)"
  ).matches
    ? "scroll"
    : "fixed";
}

function applyAdminBodyBg() {
  document.body.style.backgroundColor = "#f0f2f5";
  document.body.style.backgroundImage = "none";
  document.body.style.backgroundSize = "";
  document.body.style.backgroundPosition = "";
  document.body.style.backgroundRepeat = "";
  document.body.style.backgroundAttachment = "scroll";
}

/** Đồng bộ nền body: admin = nền panel trung tính; các route khác = nền game. */
export default function BodyBackgroundSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isAdmin = pathname.startsWith("/admin");
    if (isAdmin) {
      applyAdminBodyBg();
    } else {
      applyGameBodyBg();
    }
  }, [pathname]);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => {
      if (!window.location.pathname.startsWith("/admin")) {
        applyGameBodyBg();
      }
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return null;
}
